export default "__VITE_PUBLIC_ASSET__25ba0624__"